import { useEffect, useState } from "react";

// Tracks which in-page section is currently in view so a section nav can
// highlight it. Call it from a component rendered *after* the sections exist
// (i.e. after data has loaded). Returns [activeId, setActiveId]; clicking a nav
// entry should setActiveId so the highlight responds immediately.
export default function useTspScrollSpy(ids) {
  const [activeId, setActiveId] = useState(ids[0]);
  const key = ids.join("|");

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return undefined;
    const elements = key
      .split("|")
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (elements.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      // Ignore the sticky header at the top and the lower part of the viewport.
      { rootMargin: "-150px 0px -60% 0px" }
    );
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [key]);

  return [activeId, setActiveId];
}
